export const clinic = {
  nameJp: "渋谷美容皮膚科クリニック",
  nameEn: "SHIBUYA BEAUTY DERMATOLOGY CLINIC",
  nameShort: "SBDC",
  postal: "〒150-0043",
  address: "東京都渋谷区道玄坂2-6-14 HYビル7F",
  hours: "11:00〜20:00",
  tel: "03-6416-4392",
  telHref: "tel:0364164392",
  // 外部予約ページ（KIREIPASS）。PCヘッダー・スマホ固定CTA・各施術ページの予約CTA・FINAL CTA など
  // すべての「WEB予約」導線がここを参照する。
  webReserveUrl: "https://connect.kireipass.jp/clinics/allure-clinic/menus",
  // SBDC公式SNSの正式URL。ここを参照することで全CTA・フッター・固定CTAに反映される。
  // LINE: LINE公式アカウント管理画面「URLで追加」から取得した正式な友だち追加URL。
  lineUrl: "https://lin.ee/SkoOQgR",
  instagramUrl: "https://www.instagram.com/shibuya.beauty.clinic/",
  accessText: "JR渋谷駅・京王井の頭線 渋谷駅近く",
  googleMapUrl: "https://www.google.com/maps/search/?api=1&query=東京都渋谷区道玄坂2-6-14",
};

export const aboutSbdc = {
  headingEn: "ABOUT SBDC",
  headingJp: "一人ひとりに寄り添い、\n納得できる美容医療を。",
  paragraphs: [
    "美容医療は、見た目を変えるだけのものではありません。",
    "悩みやコンプレックスを解消し、自分に自信を持つための一つの選択肢だと私たちは考えています。",
    "渋谷美容皮膚科クリニックでは、一人ひとりのお悩みやご希望を丁寧に伺い、施術内容や料金について分かりやすくご説明したうえで、その方に合った美容医療をご提案します。",
  ],
  stat: [
    { value: "11:00", unit: "〜20:00", label: "診療時間" },
    { value: "渋谷駅", unit: "近く", label: "アクセス" },
    { value: "6", unit: "領域", label: "美容医療の対応" },
  ],
};

export const whySbdc = {
  headingEn: "WHY SBDC",
  headingJp: "SBDCが大切にしていること。",
  items: [
    { no: "01", title: "一人ひとりに合わせたご提案", text: "画一的なメニューではなく、肌質やお悩みに合わせて治療内容を組み立てます。" },
    { no: "02", title: "親身なカウンセリング", text: "話しやすい雰囲気を大切にし、気になることを遠慮なくご相談いただけます。" },
    { no: "03", title: "スタッフ全体でサポート", text: "看護師・カウンセラー・スタッフが連携し、治療後のケアまで寄り添います。" },
    { no: "04", title: "幅広い美容医療に対応", text: "医療脱毛から再生医療まで、目的に合わせて幅広くご提案できます。" },
    { no: "05", title: "渋谷駅近く・11:00〜20:00", text: "仕事や学校のあとにも通いやすい立地と診療時間です。" },
  ],
};

export const medicalPolicy = {
  headingEn: "MEDICAL POLICY",
  headingJp: "診療体制について",
  lead: "一人ひとりに合わせた美容医療を、\nチームで支える。",
  paragraphs: [
    "渋谷美容皮膚科クリニックでは、医師の診察のもと、看護師・カウンセラー・スタッフが連携し、一人ひとりのお悩みやご希望に合わせた美容医療をご提案します。",
    "施術内容だけでなく、料金や治療後のことまで分かりやすくご説明し、納得したうえで治療を選んでいただくことを大切にしています。",
  ],
  doctor: {
    nameEn: "KEIDO HARADA",
    role: "DOCTOR",
  },
  image:
    "/images/site/sbdc-top-medical-policy-v1.webp",
  imageAlt: "渋谷美容皮膚科クリニックの診療・カウンセリングイメージ",
};

export const visitFlow = {
  headingEn: "FOR FIRST VISIT",
  headingJp: "初めての方へ",
  lead: "はじめての美容医療でも、\nお気軽にご相談ください。",
  steps: [
    { no: "01", title: "ご予約", text: "WEB予約・LINE・お電話よりご希望の日時をお知らせください。", icon: "ri-calendar-check-line" },
    { no: "02", title: "ご来院・受付", text: "ご予約のお時間にご来院ください。受付にてご案内します。", icon: "ri-door-open-line" },
    { no: "03", title: "カウンセリング", text: "お悩みやご希望、生活スタイルを丁寧にお伺いします。", icon: "ri-chat-smile-2-line" },
    { no: "04", title: "医師の診察", text: "肌状態を確認し、適した治療方法をご提案します。", icon: "ri-stethoscope-line" },
    { no: "05", title: "施術・料金のご説明", text: "内容・料金・リスクについて分かりやすくご説明します。", icon: "ri-file-list-3-line" },
    { no: "06", title: "施術", text: "ご納得いただいたうえで、施術を行います。", icon: "ri-hand-heart-line" },
    { no: "07", title: "アフターケア", text: "治療後の経過を確認し、ホームケアもご案内します。", icon: "ri-heart-pulse-line" },
  ],
};

export const instagramPosts = [
  { id: "ig-1", caption: "医療脱毛のご紹介", tag: "TREATMENT", tone: "a" },
  { id: "ig-2", caption: "院内の雰囲気", tag: "CLINIC", tone: "b" },
  { id: "ig-3", caption: "お肌管理メニュー", tag: "SKIN", tone: "c" },
  { id: "ig-4", caption: "スタッフ紹介", tag: "STAFF", tone: "d" },
  { id: "ig-5", caption: "キャンペーン情報", tag: "NEWS", tone: "e" },
  { id: "ig-6", caption: "カウンセリングの流れ", tag: "GUIDE", tone: "f" },
];